// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1pC7Z","tab":"ProcedureTabs_tab__3nVGw"};